import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { VendorCreditContractBus } from '@app/cp/shared/models/VendorCreditContractBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';

@Component({
    selector: 'contract-vendor-credits',
  templateUrl: './contract-vendor-credits.component.html',
  styleUrls: ['./contract-vendor-credits.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContractVendorCreditsComponent extends BaseGridUIComponent<VendorCreditContractBus, null, ConstructionService>  {

    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
        this.aggregates = [{ field: 'totalCost', aggregate: 'sum' }];
    }
}
